---
title: A Simple “What Mattered” Reflection
description: A calm, repeatable way to reflect after a trip so you improve without overthinking.
---

# A Simple “What Mattered” Reflection

Roddo works best when you end a trip with one calm takeaway.

## Use this 3-line reflection
1) **What did I try?**  
2) **What changed?**  
3) **What will I try next time?**

## Example
- Tried: slow jig near weed edge  
- Changed: wind picked up, bites stopped  
- Next: fish the sheltered side, slower

That’s it. No hype. No pretending.

### Keep learning
- [Review your logs for patterns](/learn/app/reviewing-logs)
- [What to log (and what to skip)](/learn/app/what-to-log)
- [Roddo Learn hub](/learn)
